import { render } from "./CorrectionHistory.vue?vue&type=template&id=8fb33ecc&scoped=true"
import script from "./CorrectionHistory.vue?vue&type=script&lang=js"
export * from "./CorrectionHistory.vue?vue&type=script&lang=js"

import "./CorrectionHistory.vue?vue&type=style&index=0&id=8fb33ecc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fb33ecc"]])

export default __exports__